module.exports = __webpack_public_path__ + "static/media/ccd1.2a91b397.jpg";